import React, { useState, useEffect } from 'react';
import { Radio, Button, Input } from 'antd';
import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';

const WorkstreamActionGroupContent = ({ selectedGroup, setSelectedGroup }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isClearVisible, setIsClearVisible] = useState(false);
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);

  const allWorkstreamAttributes = [
    { key: 'None', label: 'None' },
    { key: 'actionItemNumber', label: '#', group: 'General' },
    { key: 'workstreamActionName', label: 'Name', group: 'General' },
    { key: 'Accountable Workstream', label: 'Accountable Workstream', group: 'General' },
    { key: 'Accountable subworkstream', label: 'Accountable subworkstream', group: 'General' },
    { key: 'owner', label: 'Workstream Action Owner', group: 'General' },
    { key: 'Action Status', label: 'Status', group: 'General' },
    { key: 'source', label: 'Source', group: 'General' },
    { key: 'Action Item Planning Summary', label: 'Planning summary', group: 'General' },
    { key: 'createdOn', label: 'Created on', group: 'Dates', isDate: true },
    { key: 'createdBy', label: 'Created by', group: 'General' },
    { key: 'updatedOn', label: 'Updated on', group: 'Dates', isDate: true },
    { key: 'updatedBy', label: 'Updated by', group: 'General' },
  ];

  const groupedAttributes = allWorkstreamAttributes.reduce((acc, attr) => {
    const groupName = attr.group || 'Other';
    if (!acc[groupName]) {
      acc[groupName] = [];
    }
    acc[groupName].push(attr);
    return acc;
  }, {});

  const handleMainGroupChange = (e) => {
    const newGroup = e.target.value;
    setSelectedGroup(newGroup);

    const isDateKey = allWorkstreamAttributes.find(attr => attr.key === newGroup)?.isDate;
    if (!isDateKey) {
      setSelectedDateFilter(null);
    }
  };

  const handleDateFilterChange = (e) => {
    const newDateFilter = e.target.value;
    setSelectedDateFilter(newDateFilter);
    setSelectedGroup(`${selectedGroup.split('_')[0]}_${newDateFilter}`);
  };

  const handleClear = () => {
    setSelectedGroup('None');
    setSelectedDateFilter(null);
  };

  useEffect(() => {
    setIsClearVisible(selectedGroup !== 'None' && selectedGroup !== null);
  }, [selectedGroup]);

  const selectedMainKey = selectedGroup?.includes('_') ? selectedGroup.split('_')[0] : selectedGroup;

  const filteredAttributes = allWorkstreamAttributes.filter(attr =>
    attr.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredGroupedAttributes = filteredAttributes.reduce((acc, attr) => {
    const groupName = attr.group || 'Other';
    if (!acc[groupName]) {
      acc[groupName] = [];
    }
    acc[groupName].push(attr);
    return acc;
  }, {});

  return (
    <div style={{ padding: '10px', maxHeight: '500px', overflowY: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
        <Input
          placeholder="Search attributes..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ marginRight: '8px', flex: 1 }}
          prefix={<SearchOutlined />}
        />
        {isClearVisible && (
          <Button
            type="text"
            onClick={handleClear}
            style={{ padding: 0, color: 'blue' }}
            icon={<CloseCircleOutlined />}
          >
            Clear
          </Button>
        )}
      </div>
      <Radio.Group onChange={handleMainGroupChange} value={selectedMainKey}>
        {Object.entries(filteredGroupedAttributes).map(([groupName, attributes]) => (
          <div key={groupName}>
            {groupName !== 'None' && (
              <div style={{ fontWeight: 'bold', marginTop: '10px', fontSize: 14, color: '#333' }}>
                {groupName}
              </div>
            )}
            {attributes.map((attr) => (
              <div key={attr.key}>
                <Radio value={attr.key} style={{ display: 'block' }}>
                  {attr.label}
                </Radio>
                {attr.isDate && selectedMainKey === attr.key && (
                  <div style={{ paddingLeft: '20px', marginTop: '5px' }}>
                    <Radio.Group onChange={handleDateFilterChange} value={selectedDateFilter}>
                      <Radio value="Year" style={{ display: 'block' }}>Year</Radio>
                      <Radio value="Quarter" style={{ display: 'block' }}>Quarter</Radio>
                      <Radio value="Month" style={{ display: 'block' }}>Month</Radio>
                      <Radio value="Week" style={{ display: 'block' }}>Week</Radio>
                      <Radio value="Day" style={{ display: 'block' }}>Day</Radio>
                    </Radio.Group>
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </Radio.Group>
    </div>
  );
};

export default WorkstreamActionGroupContent;